import { allSettled } from 'effector';
import { Provider } from 'effector-react';
import { GridSortModel } from '@mui/x-data-grid-pro';
import { createSortToolbarScope, sortToolbarChanged } from './model';
import { Props, SortToolbarBody } from './organisms/page';

export const SortToolbar = (props: Props) => {
  const scope = createSortToolbarScope(props.config.id);

  return (
    <Provider value={scope}>
      <SortToolbarBody {...props} />
    </Provider>
  );
};

export const sortToolbarChangedFunc = async ({
  id,
  gridSortModel,
}: {
  id: string;
  gridSortModel: GridSortModel;
}) => {
  const scope = createSortToolbarScope(id);

  await allSettled(sortToolbarChanged, { scope, params: gridSortModel });
};
